export default "__VITE_ASSET__CTpC$DFU__"